import { SvgIcon, SvgIconProps } from "@mui/material";
import * as React from "react";

export function AiSparkleIcon(props: SvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props}>
      {/* Single sparkle - 4-pointed star, sized to match Material-UI icons */}
      <path d="M12 2l2.5 7.5l7.5 2.5l-7.5 2.5l-2.5 7.5l-2.5-7.5l-7.5-2.5l7.5-2.5l2.5-7.5z" />
    </SvgIcon>
  );
}
